<template>
  <el-dialog v-el-drag-dialog :visible.sync="innerVisible" :title="$t('AirExport.BatchModificationOfReportStatus')" :width="$selectByLang('253px', '328px')" :close-on-click-modal="false">
    <el-form :label-width="$selectByLang('75px', '165px')" label-position="left">
      <el-form-item :label="$t('AirExport.CustomsClearanceStatus')">
        <el-select v-model="declareCustomsState" style="width: 120px" no="1">
          <el-option v-for="(item,index) in DECLARE_CUSTOMS_STATE" :key="index" :label="$getLangColumn(item)" :value="item.code" />
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" style="margin: 0 auto;width: fit-content;">
      <el-button type="primary" no="2" @click="okClickHandler">{{ $t('CargoMsg.Cargo_Save') }}</el-button>
      <el-button no="3" @click="innerVisible=false">{{ $t('Message.Cancel') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import { DECLARE_CUSTOMS_STATE } from '@/class/cargo/model/parameters/SystemConstants'
import { batchUpdateDeclareCustomsState } from '@/api/AirExport/airExportJob'

export default {
  name: 'UpdDeclareCustomsDialog',
  props: {
    visible: { type: Boolean, required: true },
    jobs: { type: Array, required: true }
  },
  data() {
    return {
      innerVisible: this.visible,
      DECLARE_CUSTOMS_STATE,
      declareCustomsState: 0
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
      if (!newVal) {
        this.declareCustomsState = 0
      }
    }
  },
  methods: {
    okClickHandler() {
      if (this.declareCustomsState === 0) {
        this.$message.warning(this.$t('AirExport.PleaseSelectCustomsClearanceStatus'))
        return
      }
      const loading = getLoading4Cxt(this)
      const jobKeyList = []
      for (const job of this.jobs) {
        if (job.uuid) {
          jobKeyList.push(job.uuid)
        }
      }
      batchUpdateDeclareCustomsState({ jobKeyList: jobKeyList, declareCustomsState: this.declareCustomsState }).then(res => {
        loading.close()
        this.innerVisible = false
        this.$emit('callback', res.data)
      }).catch(() => {
        loading.close()
      })
    }
  }
}
</script>
